// material-ui
import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
// project import
import Avatar from "components/@extended/Avatar";
import { PopupTransition } from "components/@extended/Transitions";

//import { deleteCustomer } from 'api/customer';
import { openSnackbar } from "api/snackbar";

// assets
import { DeleteFilled } from "@ant-design/icons";

// types
import { SnackbarProps } from "types/snackbar";
import { useAppDispatch } from "hooks";
import { deleteJopActivity } from "../../../../../store/actions/main/job-activites";
import { useState } from "react";
import { AXIOS } from "../../../../../api/axios";

interface Props {
  id: number;
  title: string;
  open?: boolean;
  handleClose?: () => void;
  fetchData?: any;
  setResult: any;
}

// ==============================|| JOB ACTIVITY - DELETE ||============================== //

export default function AlertJobDelete({
  id,
  title,
  open,
  fetchData,
  setResult,
  handleClose,
}: Props) {
  const [isDeleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleting(true);
      const response = await AXIOS.delete(`/job_activities/${id}`);
      if (response.data.status === "success") {
        setResult((prevResults) =>
          prevResults.filter((item) => item.id !== id)
        );

        openSnackbar({
          open: true,
          message: "Company deleted successfully",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: {
            color: "success",
          },
        } as SnackbarProps);
      }

      if (handleClose) handleClose();
    } catch (error) {
      console.error("Error deleting company:", error);
      openSnackbar({
        open: true,
        message: "Failed to delete company",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "error",
        },
      } as SnackbarProps);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={handleClose}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="column-delete-title"
      aria-describedby="column-delete-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar
            color="error"
            sx={{ width: 72, height: 72, fontSize: "1.75rem" }}
          >
            <DeleteFilled />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              <FormattedMessage id="Are you sure you want to delete" />
            </Typography>
            <Typography align="center">
              <FormattedMessage id="By deleting" />
              <Typography variant="subtitle1" component="span">
                {" "}
                "{title}"{" "}
              </Typography>
              <FormattedMessage id="all data assigned to that category will also be deleted" />
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button
              fullWidth
              onClick={handleClose}
              color="secondary"
              variant="outlined"
            >
              <FormattedMessage id="Cancel" />
            </Button>
            <Button
              disabled={isDeleting}
              fullWidth
              color="error"
              variant="contained"
              onClick={handleDelete}
              autoFocus
            >
              <FormattedMessage id="Delete" />
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
